export const LOGIN = 'login'
export const SET_CREATE_BUTTON = 'set_create_button'
export const SET_SEARCH_HANDLER = 'set_search_handler'
export const SET_SEARCH_STRING = 'set_searchString'
export const LOGOUT = 'logout'
export const UPDATE_INFO = 'update'
export const SET_IS_MOBILE = 'set_is_mobile'
export const SET_HEAD_BTNS = 'set_head_btns'

export const TOGGLE_ASIDE = 'toggle_aside'
export const TOGGLE_DARK = 'toggle_dark'
export const SET_TITLE = 'set_title'
export const SET_BREADCRUMBS = 'set_breadcrumbs'
export const SET_DEPARTMENT = 'set_department'
export const SET_DEPARTMENTS = 'set_departments'